import { hooks as settings } from 'core/use-cases/settings';
import { isExactRouter } from 'core/use-cases/utilities';

import { useAppSelectors } from '../selectors';

import type { App } from 'core/domains';

/**
 * Receive a key and return info of user context
 *
 */
export function useApp<T extends keyof App>(key: T) {
  const data = useAppSelectors(key);

  return data;
}

/**
 * It is responsible for checking whether to show or hide the header main on the page.
 *
 */
export function useIsHeaderMain() {
  const {
    data: { routes },
  } = settings.useSettings();

  const { isMainHeader } = routes.find(({ path }) => isExactRouter(path)) || {};

  return isMainHeader;
}
